module.exports = __webpack_public_path__ + "img/ru.519f233e.svg";